module.exports = __webpack_public_path__ + "img/GAME_SOCCER.e8f531b4.png";